module.exports = __webpack_public_path__ + "img/soundcloud.d9e8bbf3.png";